const quick = [
  { href: "#board", label: "今日热榜" },
  { href: "#features", label: "深度盘点" },
  { href: "#news", label: "疯传现场" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

const columns = [
  { name: "热梗速递", desc: "全网热梗的出处与演变" },
  { name: "疯传现场", desc: "刷屏事件的逐环拆解" },
  { name: "出圈合集", desc: "跨圈层名场面盘点" },
  { name: "吃瓜前线", desc: "热点第一现场时间线" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 px-4 pb-8 pt-14 text-background-100 md:px-8 lg:px-14">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2" aria-label="返回顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                吃瓜<span className="text-accent-400">爆网</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              全网热点雷达 + 互联网传播笔记。追踪网络爆传刷屏内容与转发过万出圈梗，深度复盘疯狂传播事件，让每一个吃瓜时刻都看得明白。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <a
                href="mailto:hello@chigua-baowang.com"
                rel="nofollow"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/20 px-4 py-2 text-xs text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className="ri-mail-line" aria-hidden="true"></i> hello@chigua-baowang.com
              </a>
              <div className="flex items-center gap-2">
                {["ri-weibo-line", "ri-bilibili-line", "ri-tiktok-fill", "ri-wechat-line"].map((c) => (
                  <a
                    key={c}
                    href="#top"
                    aria-label="社交媒体"
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-background-100/90 transition-colors hover:border-accent-400 hover:text-accent-300"
                  >
                    <i className={`${c} text-base`} aria-hidden="true"></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <nav className="md:col-span-3" aria-label="站点导航">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-accent-300">快速导航</h3>
            <ul className="mt-4 space-y-3">
              {quick.map((q) => (
                <li key={q.href}>
                  <a href={q.href} className="whitespace-nowrap text-sm text-background-100/85 transition-colors hover:text-accent-300">
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="md:col-span-4" aria-label="内容栏目">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-accent-300">四大栏目</h3>
            <ul className="mt-4 space-y-3">
              {columns.map((c) => (
                <li key={c.name}>
                  <a href="#feed" className="whitespace-nowrap text-sm text-background-100/85 transition-colors hover:text-accent-300">
                    {c.name}
                    <span className="ml-2 text-xs text-background-100/55">{c.desc}</span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-center text-xs text-background-100/60 sm:text-left">
            © 2026 吃瓜爆网 Chigua-Baowang. 理性吃瓜，快乐冲浪。
          </p>
          <p className="text-xs text-background-100/60">内容仅供参考，请勿以传播信息替代客观事实核查。</p>
        </div>
      </div>
    </footer>
  );
}